import React from 'react'
import { getImgProps, PersonProfile } from '@superhi/design'

import { API } from 'src/api'

const IMAGE_PROPS_VERTICAL = {
  small: 100,
  medium: 50,
  large: 25,
  xlarge: 25,
}

type ComponentProps = Omit<
  React.ComponentProps<typeof PersonProfile>,
  'image' | 'location' | 'facebook' | 'instagram' | 'twitter' | 'jobTitle'
>

type Props = Omit<API.PersonComponent, 'location'> &
  ComponentProps & {
    location?: string
    imageLazy?: boolean
  }

const Person: React.FC<React.PropsWithChildren<Props>> = ({
  image,
  location,
  facebook,
  instagram,
  twitter,
  imageLazy = false,
  ...props
}) => {
  const imageProps = React.useMemo(
    () => ({
      ...getImgProps(image.url, IMAGE_PROPS_VERTICAL),
      lazy: imageLazy,
    }),
    [image.url, imageLazy],
  )

  return (
    <PersonProfile
      {...props}
      image={imageProps}
      location={location || undefined}
      facebook={facebook ? `http://facebook.com/${facebook}` : undefined}
      instagram={instagram ? `http://instagram.com/${instagram}` : undefined}
      twitter={twitter ? `http://twitter.com/${twitter}` : undefined}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default Person
